import React from 'react'
import { CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";



// components
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";

// labels
import { FL_CODE, FL_GROUP } from "../../../components/i18n/formLabels";
import { PH_GROUP, PH_SEARCH_CODE } from "../../../components/i18n/placeHolders";

// actions
import { setFilter } from "../../../redux/actions/generalActions/listActions";


const TypeRestrictionFilter = props => {
    const { filter } = props.listState

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code,
        }
    });

    const onSubmit = (data, _) => props.setFilter(data);

    const cleanFields = () => {
        props.setFilter({ code: null });
        reset();
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>{FL_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={PH_SEARCH_CODE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </CardBody>

        <Row>
            <Col md="12" className="d-flex justify-content-center">
                <div className="float-right">
                    <ButtonSearch/>
                    <ButtonClean onClick={() => cleanFields()}/>
                </div>
            </Col>
        </Row>
    </Form>
}

const mapStateToProps = state => ({
    listState: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(TypeRestrictionFilter)